import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppState } from '../../state';

export default function PrivateRoute({ children }: { children: React.ReactElement }) {
  const { isAuthReady, user } = useAppState();
  const location = useLocation();

  const renderChildren = user || !process.env.REACT_APP_SET_AUTH;

  if (!renderChildren && !isAuthReady) {
    return null;
  }

  return renderChildren ? children : <Navigate to="/login" state={{ from: location }} replace />;
}
